import React, { useCallback, useState } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import Currency from 'components/currency';
import { Box } from 'components/ui';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { DonationsModal } from 'pages/cart/donations-modal';
import { IconContainer } from 'pages/cart/your-cart/styled';
import { layout, spacing } from 'styles/constants';
import { hiddenAccessibilityPlatformProps } from 'utils/accessibility';

import { DonationLabel, Total, TotalsRow } from './styled';
import { IDonationsRowProps } from './types';

const DonationsRow: React.FC<React.PropsWithChildren<IDonationsRowProps>> = ({
  isLoading,
  iconAriaLabel,
  totalCents,
  message,
  modalContent,
  textProps,
}) => {
  const [showDonationsInfoModal, setShowDonationsInfoModal] = useState(false);

  const onOpenCallback = useCallback(() => {
    if (!modalContent) {
      return;
    }
    setShowDonationsInfoModal(true);
  }, [setShowDonationsInfoModal, modalContent]);

  const onCloseCallback = useCallback(() => {
    setShowDonationsInfoModal(false);
  }, [setShowDonationsInfoModal]);

  return (
    <>
      <TotalsRow>
        {isLoading ? (
          <CurrencyLineSkeleton />
        ) : (
          <Box style={styles.row}>
            <Box style={styles.labelContainer}>
              <DonationLabel {...(textProps && { ...textProps })}>{message}</DonationLabel>
              {iconAriaLabel && (
                <IconContainer
                  maxWidth={'$5'}
                  accessibilityLabel={iconAriaLabel}
                  onPress={onOpenCallback}
                >
                  <Icon
                    alignSelf={'center'}
                    variant="infoFill"
                    width="$3_5"
                    size={'xs'}
                    {...hiddenAccessibilityPlatformProps}
                  />
                </IconContainer>
              )}
            </Box>
            <Total testID="total-donation">
              <Currency textProps={textProps} amount={totalCents} />
            </Total>
          </Box>
        )}
      </TotalsRow>
      {modalContent && (
        <DonationsModal
          isOpen={showDonationsInfoModal}
          onCloseCallback={onCloseCallback}
          title={modalContent.title}
          modalAppearanceEventMessage={modalContent.modalAppearanceEventMessage}
          testID="tims-camps-donation-modal"
        >
          {modalContent.body}
        </DonationsModal>
      )}
    </>
  );
};

export default DonationsRow;

const styles = StyleSheet.create({
  labelContainer: {
    alignItems: 'center',
    flexDirection: 'row',
    maxHeight: spacing.$5,
  },
  row: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'space-between',
    maxHeight: spacing.$5,
    width: layout.full,
  },
});
